<template>

    <div>
      <ul class="nav mb-4">
          <li class="nav-item"><router-link to="/mapa" class="mr-1 p-2 nav-link ">MAPA</router-link></li>
      </ul>
      <span><strong>- MAPAS <i class="fas fa-chevron-right"></i> GRÁFICO</strong></span>

    </div>
</template>

<script>

export default {
  name: 'Mapas'
}
</script>

<style scoped>

a {
  background-color: #18A689;
  color: #fff;
  font-size: 12px;
  text-decoration: none;
}

a:hover {
  background-color: #fff;
  color: #2c2c2c;
}

</style>
